import React from "react";
import { useAccountStore } from "../zustand/account";
import { Button, Group, Modal, Text, Stack } from "@mantine/core";
import { editorModalShell, editorModalStrongTitleStyles } from "../styleFile";


export default function DeleteProjectModal({deleteID}) {

  const {deleteSpecificUserProject, updateDeleteModalOpen, deleteModalOpen, getUserProjects} = useAccountStore();

  const onDeleteSubmit = () => {

      deleteSpecificUserProject(deleteID).then(() => getUserProjects())
      updateDeleteModalOpen()

  }

  const onDeleteCancel = () => {
    updateDeleteModalOpen()
  }

  return (
    <Modal
      opened={deleteModalOpen}
      onClose={onDeleteCancel}
      title="Delete project?"
      centered={editorModalShell.centered}
      radius={editorModalShell.radius}
      overlayProps={editorModalShell.overlayProps}
      styles={editorModalStrongTitleStyles}
      size={400}
      withCloseButton
    >
      <Stack gap="lg" p={20}>
        <Text size="sm" c="dimmed" style={{ lineHeight: 1.55 }}>
          This permanently removes the project for your account. This cannot be undone.
        </Text>
        <Group justify="flex-end" gap="sm">
          <Button variant="default" radius={editorModalShell.radius} onClick={() => onDeleteCancel()}>
            Cancel
          </Button>
          <Button color="red" radius={editorModalShell.radius} onClick={() => onDeleteSubmit()}>
            Delete
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}